import { createContext, useEffect, useState } from "react";

export const Context = createContext();

const ContextProvider = ({ children }) => {
  const [isMobile, setIsMobile] = useState();

  useEffect(() => {
    setIsMobile(window.innerWidth < 878);
    const handleResize = () => setIsMobile(window.innerWidth < 878);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return <Context.Provider value={{ isMobile }}>{children}</Context.Provider>;
};

export default ContextProvider;
